import React from 'react';
import { Drawer } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useCookies } from 'react-cookie';
import { CookieKey } from 'common/config/cookieKeys';
import { AgreementLink } from 'common/config/agreementLinks';
import styled from 'styled-components';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;

    // FormattedMessage doesn't render whitespace before tag
    a {
      margin-left: 4px;
    }
  }
`;

export const CookieInfo = () => {
  const intl = useIntl();
  const [cookies, setCookie] = useCookies([CookieKey.CookiePolicyDismissed]);

  return (
    <StyledDrawer
      visible={!cookies.cpd}
      placement="bottom"
      height={75}
      mask={false}
      onClose={() => {
        setCookie(CookieKey.CookiePolicyDismissed, '1');
      }}
    >
      <FormattedMessage
        id="cookies.message"
        values={{
          termsAndConditions: (
            <a
              href={AgreementLink.TermsAndConditions}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: 'cookies.termsAndConditions' })}
            </a>
          ),
          privacyPolicy: (
            <a
              href={AgreementLink.PrivacyPolicy}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: 'cookies.privacyPolicy' })}
            </a>
          ),
        }}
      />
    </StyledDrawer>
  );
};
